module.exports = __webpack_public_path__ + "img/马桶上方收纳.34b5f6fc.webp";